
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("9bT6H"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("9bT6H", function(module, exports) {

let $6b0fe341b8152101$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6b0fe341b8152101$var$load("h3ABO"),
    $6b0fe341b8152101$var$load("9hYRW"),
    $6b0fe341b8152101$var$load("kpm7S"),
    $6b0fe341b8152101$var$load("5wC2D"),
    $6b0fe341b8152101$var$load("2YffH"),
    $6b0fe341b8152101$var$load("g7ggm"),
    $6b0fe341b8152101$var$load("eEyVs"),
    $6b0fe341b8152101$var$load("6mHrv"),
    $6b0fe341b8152101$var$load("awWN9"),
    $6b0fe341b8152101$var$load("9CYct"),
    $6b0fe341b8152101$var$load("fsEiA"),
    $6b0fe341b8152101$var$load("dQYOB"),
    $6b0fe341b8152101$var$load("hZtKG"),
    $6b0fe341b8152101$var$load("dkqvW"),
    $6b0fe341b8152101$var$load("lVO3w"),
    $6b0fe341b8152101$var$load("hyzoX"),
    $6b0fe341b8152101$var$load("h9Ed7"),
    $6b0fe341b8152101$var$load("eBRUf"),
    $6b0fe341b8152101$var$load("kbRvk"),
    $6b0fe341b8152101$var$load("tKhaz"),
    $6b0fe341b8152101$var$load("hwT9D"),
    $6b0fe341b8152101$var$load("j4Bpe"),
    $6b0fe341b8152101$var$load("cD6Zr"),
    $6b0fe341b8152101$var$load("k3jER"),
    $6b0fe341b8152101$var$load("9wzNh"),
    $6b0fe341b8152101$var$load("8YSo7"),
    $6b0fe341b8152101$var$load("9ldRJ"),
    $6b0fe341b8152101$var$load("50ame"),
    $6b0fe341b8152101$var$load("7do1E"),
    $6b0fe341b8152101$var$load("77dkW"),
    $6b0fe341b8152101$var$load("1MlIV"),
    $6b0fe341b8152101$var$load("6iz6l"),
    $6b0fe341b8152101$var$load("4SCW2"),
    $6b0fe341b8152101$var$load("aXHNO"),
    $6b0fe341b8152101$var$load("kmvek"),
    $6b0fe341b8152101$var$load("Wowvf"),
    $6b0fe341b8152101$var$load("421lv"),
    $6b0fe341b8152101$var$load("dek7I"),
    $6b0fe341b8152101$var$load("3SmkN"),
    $6b0fe341b8152101$var$load("dYtBN"),
    $6b0fe341b8152101$var$load("kNV5Y"),
    $6b0fe341b8152101$var$load("6wr18"),
    $6b0fe341b8152101$var$load("kjZZD"),
    $6b0fe341b8152101$var$load("7cDV0"),
    $6b0fe341b8152101$var$load("ijD5W"),
    $6b0fe341b8152101$var$load("3JSgG"),
    $6b0fe341b8152101$var$load("37ldp"),
    $6b0fe341b8152101$var$load("ffEVr"),
    $6b0fe341b8152101$var$load("9AXkC"),
    $6b0fe341b8152101$var$load("28arV"),
    $6b0fe341b8152101$var$load("hhss7"),
    $6b0fe341b8152101$var$load("l1BQC"),
    $6b0fe341b8152101$var$load("jlSF3"),
    $6b0fe341b8152101$var$load("dP7ao"),
    $6b0fe341b8152101$var$load("hogcU"),
    $6b0fe341b8152101$var$load("dkgtP"),
    $6b0fe341b8152101$var$load("g43Ev"),
    $6b0fe341b8152101$var$load("7EorR"),
    $6b0fe341b8152101$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.ed94370c.js.map
